/*
 * @author        david.loehr@zumper.com
 * @copyright     Copyright (c) 2024, Zumper
 */
export const __typename = 'SerializableMap'
export const ENTRIES = 'e'

export type RawSerializableMap<Key, Value> = {
  readonly __typename: typeof __typename
} & {
  readonly [E in typeof ENTRIES]: ReadonlyArray<readonly [Key, Value]>
}

export declare class SerializableMap<Key, Value> implements ReadonlyMap<Key, Value> {
  static isRawSerializableMap(
    iterableOrEntries: unknown
  ): iterableOrEntries is RawSerializableMap<unknown, unknown>
  static isRawSerializableMapOfType<Key, Value>(
    iterableOrEntries: unknown,
    keyTypeGuard: (key: unknown) => key is Key,
    valueTypeGuard: (value: unknown) => value is Value
  ): iterableOrEntries is RawSerializableMap<Key, Value>
  constructor(
    iterableOrEntries?:
      | RawSerializableMap<Key, Value>
      | Iterable<readonly [Key, Value]>
      | readonly (readonly [Key, Value])[]
      | null
  )
  forEach(callbackfn: (value: Value, key: Key, map: ReadonlyMap<Key, Value>) => void): void
  get(key: Key): Value | undefined
  has(key: Key): boolean
  readonly size: number
  entries(): ReturnType<ReadonlyMap<Key, Value>['entries']>
  keys(): ReturnType<ReadonlyMap<Key, Value>['keys']>
  toJSON(): RawSerializableMap<Key, Value>
  values(): ReturnType<ReadonlyMap<Key, Value>['values']>
  toJSON(): RawSerializableMap<Key, Value>

  filter<E extends readonly [key: Key, value: Value]>(
    predicate: (entry: readonly [key: Key, value: Value]) => entry is E
  ): SerializableMap<E[0], E[1]>
  filter(
    predicate: (entry: readonly [key: Key, value: Value]) => unknown
  ): SerializableMap<Key, Value>

  /**
   * Returns a copy of this `SerializableMap` with `key` set to `value`
   */
  with(key: Key, value: Value): SerializableMap<Key, Value>
  [Symbol.iterator](): ReturnType<ReadonlyMap<Key, Value>['entries']>
}
